import React from "react";

const DiamondFooter = () => (
  <footer
    data-testid="diamond-footer"
    className="w-full border-t border-white/5 bg-black/50 backdrop-blur-sm py-5 px-4 text-center relative z-10"
  >
    <p className="text-[10px] uppercase tracking-[0.32em] text-white/40 font-light" style={{ textShadow: "0 1px 3px rgba(0,0,0,0.7)" }}>
      Powered by{" "}
      <a
        href="https://diamondinnovations.eu"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="diamond-footer-link"
        className="text-[#B2A475]/70 hover:text-[#B2A475] transition-colors font-normal"
      >
        Diamond Innovations
      </a>
    </p>
  </footer>
);

export default DiamondFooter;
